// Copyright (c) 2017 Comsearch, Inc., All rights reserved

// https://github.com/reduxjs/redux-toolkit/issues/2008
import 'symbol-observable'

import React from 'react'
import ReactDOM from 'react-dom'
import { createHashHistory } from 'history'
import { Provider } from 'react-redux'
import thunk from 'redux-thunk'
import * as reducers from 'redux/modules'
import Routes from './Routes'

import {
  routerMiddleware,
  routerReducer,
} from 'react-router-redux'

import {
  reducer as formReducer,
} from 'redux-form'

import {
  reducer as notifications,
} from 'react-notification-system-redux'

import {
  applyMiddleware,
  combineReducers,
  compose,
  createStore,
} from 'redux'

import './favicons'
import 'whatwg-fetch'

import 'jodit/build/jodit.min.css'
import './styles/index.scss'

import Modal from 'react-modal'

// for accessibility reasons, react-modal needs to know
// the application's parent node.
Modal.setAppElement('#app')

const reducer = combineReducers({
  ...reducers,
  form: formReducer,
  routing: routerReducer,
  notifications,
})

// NOTE: if HTML5 history is preferred at any point, be sure to refactor <AuthWrapper />
// where::   window.location.hash !== '#/login'
const history = createHashHistory()
const store = createStore(
  reducer,
  undefined,
  compose(
    applyMiddleware(routerMiddleware(history), thunk),
    window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
  )
)

ReactDOM.render(
  <Provider store={store}>
    <Routes history={history} />
  </Provider>,
  document.getElementById('app')
)
